import { ODataOptions } from '../util/ODataBuilder';
import BaseApi from './BaseApi';

import PersonnelModel from '../models/personnel/Personnel';

export interface IPersonnel {
    getAll(options: ODataOptions, jwt: string): Promise<object>;
    get(personnelId: number, jwt: string): Promise<object>;
    create(personnel: PersonnelModel, jwt: string): Promise<object>;
    update(personnel: PersonnelModel, jwt: string): Promise<object>;
    delete(personnelId: number, jwt: string): Promise<object>;
}

export default class Personnel extends BaseApi implements IPersonnel {
    constructor(baseUrl: string) {
        super(baseUrl);

        this.getAll = this.getAll.bind(this);
        this.get = this.get.bind(this);
        this.create = this.create.bind(this);
        this.update = this.update.bind(this);
        this.delete = this.delete.bind(this);
    }

    public getAll(options: ODataOptions, jwt: string): Promise<object> {
        return this.getRequest(`${this.baseUrl}v1.0/landmen${options.toString()}`, jwt);
    }

    public get(personnelId: number, jwt: string) {
        return this.getRequest(`${this.baseUrl}v1.0/landmen/${personnelId}`, jwt);
    }

    public create(personnel: PersonnelModel, jwt: string) {
        console.log('calling create', personnel);
        return this.postRequest(`${this.baseUrl}v1.0/landmen`, personnel, jwt);
    }

    public update(personnel: PersonnelModel, jwt: string) {
        return this.putRequest(`${this.baseUrl}v1.0/landmen/${personnel.id}`, personnel, jwt);
    }

    public delete(personnelId: number, jwt: string) {
        return this.deleteRequest(`${this.baseUrl}v1.0/landmen/${personnelId}`, undefined, jwt);
    }
}


// WEBPACK FOOTER //
// ./src/api/Personnel.ts